import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function StatementStatusUpsert(param: any) {

    let [statementStatus, setStatementStatus] = useState<any>(param?.editDataDawer ?? []);

    console.log(param)

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            statementStatus = param?.editDataDawer
            setStatementStatus(statementStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveStatusStatement(statementStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Statement Status Saved', 'Success')
        })
    }

    return (<>
        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Statement Status </h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-12">

                            <div className="form-format">
                                <label className="control-label">Statement Status UseID</label>
                                <div className="label-entries">
                                    <input type="number" placeholder="Statement Status Use ID" ng-disabled="IsDisabled" data-ng-model="statementStatus.statementStatusUseID" id="statementStatusUseID" name="statementStatusUseID" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label"> Statement Status Name</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Statement Status Name" data-ng-model="statementStatus.statementStatusName" id="statementStatusName" name="statementStatusName" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Statement Status Short Code</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Statement Status Short Code" data-ng-model="statementStatus.statementStatusShortCode" id="statementStatusShortCode" name="statementStatusShortCode" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12">

                            <div className="ws-6">
                                <div className="mbl">
                                    RecMYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.recMYN" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.recMYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.recMYN=='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    PublYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.publYN" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.publYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.publYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    MechYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.mechYN" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.mechYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.mechYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    ApprovalYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.approvalYN" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.approvalYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.approvalYN =='1'">No</span>
                                    </label>
                                </div>
                            </div>

                            <div className="ws-6">
                                <div className="mbl">
                                    ControlRptYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.controlRptYN" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.controlRptYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.controlRptYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    EmailYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.emailYN" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.emailYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.emailYN =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    AutoLTD
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.autoLTD" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.autoLTD=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.autoLTD =='1'">No</span>
                                    </label>
                                </div>
                                <div className="mbl">
                                    IsDefault
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="statementStatus.isDefault" />
                                        <span className="slider round text-left white pm pts " ng-show="statementStatus.isDefault=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!statementStatus.isDefault =='1'">No</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>Save </button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>Reset </button>
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>Close  </button>
                </div>
            </div>

        </Drawer>
    </>)
}